// @flow

import { SET_REGISTRATION_VALIDATION_ERRORS } from './mutation-types'
import Vue from 'vue'
import type { RegistrationPayload } from '../../../types/registration-payload'
import type { ActionContext } from 'vuex'
import { PASSWORDS_DO_NOT_MATCH } from '../../../user-api/user-api-client-constants'

export default {
  async validateRegistration ({commit}: ActionContext<mixed, mixed>, {customerDetails, address, credentials}: RegistrationPayload) {
    try {
      const {passwordConfirm, ...accountCredentials} = credentials
      const validateResult = await Vue.prototype.$container.userApiClient.validateRegistration(customerDetails, address, accountCredentials)
      const validationErrors = validateResult.errors || []
      if (passwordConfirm !== accountCredentials.password) {
        validationErrors.push({
          code: PASSWORDS_DO_NOT_MATCH,
          propertyPath: 'account.passwordConfirm',
          message: 'Passwords do not match'
        })
      }

      commit(SET_REGISTRATION_VALIDATION_ERRORS, validationErrors)
    } catch (e) {
    }
  },
  async resetValidationErrors ({commit}: ActionContext<mixed, mixed>) {
    commit(SET_REGISTRATION_VALIDATION_ERRORS, [])
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/registration/actions.js